import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CMS PAYMENT RELATED APIs
// ==============================================

// 1. Get CMS Years (GET)
export const getCMSYears = async () => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetCMSYears`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get CMS Months by Year (GET)
export const getCMSMonthsByYear = async (params) => {
    try {
        const { year, lType, contraCode, eType } = params;

        // Validate required parameters
        if (!year) {
            throw new Error('Year is required');
        }

        // Build query parameters
        const queryParams = new URLSearchParams({
            Year: year,
            LType: lType || '',
            ContraCode: contraCode || '',
            EType: eType || ''
        });


        const response = await axios.get(
            `${API_BASE_URL}/HR/GetCMSMonthsbyYear?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Cost Centers for CMS Payment (GET)
export const getCCForCMSPayment = async (params) => {
    try {
        const { year, month } = params;

        // Validate required parameters
        if (!year) {
            throw new Error('Year is required');
        }
        if (!month) {
            throw new Error('Month is required');
        }

        // Build query parameters
        const queryParams = new URLSearchParams({
            Year: year,
            Month: month
        });


        const response = await axios.get(
            `${API_BASE_URL}/HR/GetCCForCMSPayment?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Groups for CMS Payment (POST) - FIXED TO SEND ARRAY
export const getGroupForCMSPay = async (params) => {
    try {

        // Validate required parameters
        if (!params.year) {
            throw new Error('Year is required');
        }
        if (!params.month) {
            throw new Error('Month is required');
        }
        if (!params.ccCodes || !Array.isArray(params.ccCodes) || params.ccCodes.length === 0) {
            throw new Error('Cost Center Codes array is required');
        }

        // ✅ Send array format - backend will handle the conversion
        const payload = {
            Year: params.year.toString(),
            EffectiveMonth: params.month.toString(),
            SelectedCC: params.ccCodes  // Send as array ["CC-143", "CC-144"]
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/GetGroupForCMSPay`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Consolidate Numbers for CMS Payment (POST) - FIXED TO SEND ARRAYS
export const getConsolidateNoForCMSPay = async (params) => {
    try {

        // Validate required parameters
        if (!params.year) {
            throw new Error('Year is required');
        }
        if (!params.month) {
            throw new Error('Month is required');
        }
        if (!params.ccCodes || !Array.isArray(params.ccCodes) || params.ccCodes.length === 0) {
            throw new Error('Cost Center Codes array is required');
        }
        if (!params.groups || !Array.isArray(params.groups) || params.groups.length === 0) {
            throw new Error('Groups array is required');
        }

        // ✅ Send array format - backend will handle the conversion
        const payload = {
            Year: params.year.toString(),
            EffectiveMonth: params.month.toString(),
            SelectedCC: params.ccCodes,     // Send as array
            SelectedGroup: params.groups    // Send as array
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/GetConsolidateNoForCMSPay`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 6. Get Employees for CMS Data (POST) - FIXED TO SEND ARRAYS
export const getEmpForCMSData = async (params) => {
    try {

        // Validate required parameters
        if (!params.year) {
            throw new Error('Year is required');
        }
        if (!params.month) {
            throw new Error('Month is required');
        }
        if (!params.ccCodes || !Array.isArray(params.ccCodes) || params.ccCodes.length === 0) {
            throw new Error('Cost Center Codes array is required');
        }
        if (!params.consolidateNos || !Array.isArray(params.consolidateNos) || params.consolidateNos.length === 0) {
            throw new Error('Consolidate Numbers array is required');
        }
        if (!params.groups || !Array.isArray(params.groups) || params.groups.length === 0) {
            throw new Error('Groups array is required');
        }

        // ✅ Send array format - backend will handle the conversion
        const payload = {
            Year: params.year.toString(),
            EffectiveMonth: params.month.toString(),
            SelectedCC: params.ccCodes,              // Send as array
            SelectedConsolidateNo: params.consolidateNos,  // Send as array
            SelectedGroup: params.groups             // Send as array
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/GetEmpForCMSData`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 7. Save CMS Employees Data (POST)
export const saveCMSEmployeesData = async (params) => {
    try {

        // Validate required parameters
        if (!params.year) {
            throw new Error('Year is required');
        }
        if (!params.month) {
            throw new Error('Month is required');
        }
        if (!params.empRefNos) {
            throw new Error('Employee Reference Numbers are required');
        }
        if (!params.consolidateNos) {
            throw new Error('Consolidate Numbers are required');
        }
        if (!params.ccCodes) {
            throw new Error('Cost Center Codes are required');
        }
        if (!params.netAmts) {
            throw new Error('Net Amounts are required');
        }
        if (!params.payrollTranNo) {
            throw new Error('Payroll Transaction Number is required');
        }
        if (!params.roleId) {
            throw new Error('Role ID is required');
        }
        if (!params.createdBy) {
            throw new Error('Created By is required');
        }
        if (!params.payDate) {
            throw new Error('Payment Date is required');
        }

        // Format the date
        const formattedDate = params.payDate instanceof Date 
            ? params.payDate.toISOString().split('T')[0]
            : params.payDate;

        // ✅ Use PascalCase to match C# model properties
        const payload = {
            Year: parseInt(params.year),
            EffectiveMonth: parseInt(params.month),
            CMSEmprefnos: params.empRefNos.toString().trim(),
            CMSCosnosidatenos: params.consolidateNos.toString().trim(),
            CMSCCs: params.ccCodes.toString().trim(),
            CMSAmts: params.netAmts.toString().trim(),
            TransactionRefno: params.payrollTranNo.toString().trim(),
            Roleid: parseInt(params.roleId),
            CreatedBy: params.createdBy.toString().trim(),
            PaymentDate: formattedDate
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/SaveCMSEmployeesData`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        
        // Return the response data directly
        return response.data;
    } catch (error) {

        if (error.response?.data) {
            throw error.response.data;
        }
        throw error.message || 'Failed to save CMS Employees Data';
    }
};